// Display wording only: never use this label as a filter value or API parameter.
export function unassignedChatLabel(policy, audience) {
  return policy?.known === true && policy.enabled === true && audience === 'customer'
    ? 'In queue' : 'Unassigned';
}

export function isWatiBotHeld(chat) {
  const assignment = chat?._canonical?.assignment;
  const hasOwner = assignment && Object.prototype.hasOwnProperty.call(assignment, 'assigned_to')
    ? Boolean(assignment.assigned_to)
    : chat?.agent_id != null || Boolean(chat?.agent && chat.agent !== 'Bot');
  return !hasOwner && ((assignment?.provider_assignee ?? chat?.provider_assignee)?.kind === 'bot' || chat?.agent === 'Bot');
}
